import React, { ReactElement, useContext, useEffect, useState } from "react";
import { ToolbarContext } from "./toolbarContext";
import { ToolbarActionType } from "./toolbarReducer.types";
import { ToolbarItemProps } from "../components/toolbar-item.types";

/**
 * A component whose sole purpose is to measure the width of all toolbar
 * items before deciding whether they belong to the "visible" or "show more"
 * container. The component is mounted only for the time of measurement.
 * It is then removed from the DOM.
 */
export const MeasureHelper = ({
  renderToolbarItem,
}: {
  renderToolbarItem: (item: ToolbarItemProps) => ReactElement;
}): ReactElement => {
  const { state, dispatch } = useContext(ToolbarContext);
  const [element, setElement] = useState<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (element) {
      const toolbarItemsWidth = Array.from(
        element.querySelectorAll(".spark-toolbar__item")
      ).map((item) => ({ width: item?.clientWidth ?? 0 }));

      dispatch({
        type: ToolbarActionType.SET_ITEMS_WIDTH,
        toolbarItemsWidth,
      });
    }
  }, [dispatch, element]);

  return (
    <span
      ref={(node): void => {
        if (node && node?.clientHeight > 0) {
          setElement(node);
        }
      }}
    >
      {state.toolbarSchema?.map((item) => renderToolbarItem(item))}
    </span>
  );
};
